import {
  ensureConsoleCaptureInstalled,
  setConsoleCaptureMode,
  type ConsoleCaptureMode
} from './utils/consoleCapture'

/** Apply capture mode after visibility is known. Install is a no-op if main already did it. */
export function initializeDebugToolCapture(captureMode: ConsoleCaptureMode): void {
  ensureConsoleCaptureInstalled()
  setConsoleCaptureMode(captureMode)
}
